// `is_active` comes on every user the backend lists: false once the account is
// deactivated (/users/deactivate), missing for anyone from before the flag --
// who counts as active.
export interface MaybeActive {
  is_active?: boolean | null;
}

// Takes any object: plenty of screens type their staff without is_active.
export const isActiveUser = (u?: object | null): boolean => (u as MaybeActive | null)?.is_active !== false;

// For pickers and filters: nobody should be assigned or filtered to someone who
// can no longer log in. Keep the full list for name lookups on existing rows.
export const activeOnly = <T extends object>(list?: T[] | null): T[] => (list || []).filter(isActiveUser);
